<template>
  <div class="profile-page">
    <div class="w-full flex justify-center items-center float-left mt-10">
      <div class="px-10 py-12 shadow rounded-xl float-left">
        <div class="w-full" style="max-width: 400px">
          <div class="w-full float-left">
            <h1 class="font-medium text-black text-2xl w-80 text-left">
              {{ $t("profile.title") }}
            </h1>
          </div>
          <Form class="w-full float-left" @submit="submit()" :validation-schema="formValidation"
            style="max-width: 400px">
            <span class="float-left mt-4" v-if="errorMessage">{{
              errorMessage
            }}</span>

            <div class="mt-6 float-left w-full">
              <label class="text-gray">{{ $t("login.full-name") }}</label>
              <Field type="text" name="fullName" class="float-left w-full" :placeholder="$t('login.full-name')"
                v-model="fullName" />
              <ErrorMessage class="float-left small-font" name="fullName" />
            </div>
            <div class="mt-6 float-left w-full">
              <label class="text-gray">{{ $t("login.business-name") }}</label>
              <Field type="text" name="businessName" class="float-left w-full" :placeholder="$t('login.business-name')"
                v-model="businessName" />
              <ErrorMessage class="float-left small-font" name="businessName" />
            </div>


            <div class="float-left w-full mt-12" style="max-width: 400px">
              <button class="btn" :disabled="loading">
                <div class="spring-spinner" v-if="loading">
                  <div class="spring-spinner-part top">
                    <div class="spring-spinner-rotator"></div>
                  </div>
                  <div class="spring-spinner-part bottom">
                    <div class="spring-spinner-rotator"></div>
                  </div>
                </div>
                <span class="text-white text-center" v-else>{{
                  $t("profile.update")
                }}</span>
              </button>

            </div>


          </Form>
        </div>
      </div>
    </div>
    
    <!-- Footer with Contact Info -->
    <footer class="contact-footer" v-if="contactInfo">
      <div class="footer-content">
        <h3 class="footer-title">{{ $t("profile.contact-info") }}</h3>
        <div class="contact-details">
          <div class="contact-item" v-if="contactInfo.SNAP_DRIVE_PHONE">
            <a :href="`tel:${contactInfo.SNAP_DRIVE_PHONE}`" class="contact-link">
              <i class="pi pi-phone contact-icon"></i>
              <span class="contact-value">{{ contactInfo.SNAP_DRIVE_PHONE }}</span>
            </a>
          </div>
          <div class="contact-item" v-if="contactInfo.SNAP_DRIVE_EMAIL">
            <a :href="`mailto:${contactInfo.SNAP_DRIVE_EMAIL}`" class="contact-link">
              <i class="pi pi-envelope contact-icon"></i>
              <span class="contact-value">{{ contactInfo.SNAP_DRIVE_EMAIL }}</span>
            </a>
          </div>
          <div class="contact-item" v-if="contactInfo.SNAP_DRIVE_WHATSAPP">
            <a :href="`https://wa.me/${getWhatsAppDisplayNumber(contactInfo.SNAP_DRIVE_WHATSAPP)}`" target="_blank" class="contact-link">
              <i class="pi pi-whatsapp contact-icon"></i>
              <span class="contact-value">{{ getWhatsAppDisplayNumber(contactInfo.SNAP_DRIVE_WHATSAPP) }}</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import CheckBox from "@/components/CheckBox.vue";
import { Field, Form, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import { useI18n } from "vue-i18n";

export default {
  name: "Profile",
  title: "Profile",
  components: {
    CheckBox,
    Field,
    Form,
    ErrorMessage,
  },
  data() {
    let formValidation = this.setErrorMessage();
    return {

      fullName: "",
      businessName: "",
      formValidation,
      errorMessage: "",
      errorMessagePath: "",
      loading: false,
      contactInfo: null,
      loadingContactInfo: false,
    };
  },
  mounted() {
    const user = this.$store.getters.getUser;
    this.fullName = user.full_name;
    this.businessName = user.hotel_name;
    this.fetchContactInfo();
  },
  methods: {
    submit() {
      this.loading = true;

      this.axios
        .post(this.$store.state.rootAPI + "update-info", {
          full_name: this.fullName,
          hotel_name: this.businessName
        })
        .then((res) => {
          this.$notify({
            title: this.$t("profile.updated-title"),
            text: this.$t("profile.updated-txt"),
            type: "success",
          });
          this.$nextTick(() => {
            this.$store.dispatch("updateInfo", {
              full_name: this.fullName,
              hotel_name: this.businessName
            });
          });
        })
        .catch((err) => {
          this.$notify({
            title: this.$t("general.error"),
            text: err.response.data.message || err.message,
            type: "error",
          });
          this.errorMessage = err;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setErrorMessage() {

      return yup.object({

        fullName: yup
          .string()
          .min(2, this.$t("errors.fullName.min"))
          .max(150, this.$t("errors.fullName.max"))
          .required(this.$t("errors.fullName.required")),

        businessName: yup
          .string()
          .min(2, this.$t("errors.businessName.min"))
          .max(150, this.$t("errors.businessName.max"))
          .required(this.$t("errors.businessName.required")),


      });
    },
    fetchContactInfo() {
      this.loadingContactInfo = true;
      this.axios
        .get(this.$store.state.rootAPI + "setting")
        .then((res) => {
          this.contactInfo = res.data.data || res.data;
        })
        .catch((err) => {
          console.error("Error fetching contact info:", err);
          // Silently fail - don't show error notification for footer
        })
        .finally(() => {
          this.loadingContactInfo = false;
        });
    },
    getWhatsAppDisplayNumber(number) {
      if (!number) return "";
      // Remove all non-numeric characters
      const cleaned = number.replace(/[^0-9]/g, "");
      // If it doesn't start with 0, add 0 at the beginning
      return cleaned.startsWith("0") ? cleaned : "0" + cleaned;
    },
 
  },
  watch: {
    "$i18n.locale": function () {
      this.formValidation = this.setErrorMessage();
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  width: 100%;
  max-width: 400px;
}

.no-account {
  font-size: small;
  max-width: 400px;

  a {
    color: blue;
  }
}

.small-font {
  font-size: small;
}

.profile-page {
  width: 100%;
  float: left;
  min-height: calc(100vh - 64px);
  padding-bottom: 150px; /* Space for fixed footer */
}

.contact-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 2rem 1rem;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
  z-index: 10;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.footer-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  text-align: center;
}

.contact-details {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem 2rem;
}

.contact-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 200px;
}

.contact-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  gap: 0.5rem;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
}

.contact-icon {
  font-size: 1.5rem;
  color: #27a432;
  margin-bottom: 0.25rem;
}

.contact-value {
  font-size: 1rem;
  color: #27a432;
  text-decoration: none;
  word-break: break-word;
  text-align: center;
}

@media (max-width: 768px) {
  .contact-details {
    flex-direction: column;
    gap: 1rem;
  }

  .contact-item {
    min-width: auto;
    width: 100%;
  }
}
</style>
